import React from "react";
import AppCard from "../../components/app-card/AppCard";
import { useMarketplace } from "../../hooks";

import { AppsContainer, AppsContainerLot, AppsHeaderContainer } from "./components";

const CategoryApps = ({ category }) => {
  const { applications } = useMarketplace({ categoryId: category?.id });
  return (
    <>
      {applications?.length ? (
        <>
          <AppsHeaderContainer>{category.name}</AppsHeaderContainer>
          <AppsContainerLot>
            <AppsContainer>
              {applications?.map((app, i) => (
                <AppCard
                  key={app?.id}
                  small
                  rating={5 - (i % 5)}
                  name={app?.name}
                  icon={app?.icon}
                />
              ))}
            </AppsContainer>
          </AppsContainerLot>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default CategoryApps;
